import React, {FC} from 'react';

import {Icon, VenmoWordmark as VenmoIcon} from '@optimaxdev/icons';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature} from 'components/feature';
import {ApplicationStoreType} from 'desktop/store';

import {STEPS} from '../../constants/checkout';
import {PAYMENTS} from '../../constants/paymentStep';
import {useGetErrorAndSendAnalytics} from '../../hooks/primer/useGetErrorAndSendAnalytics/useGetErrorAndSendAnalytics';
import {usePrimerForRedirectablePayments} from '../../hooks/primer/usePrimerForRedirectablePayments';
import {getCurrentStep} from '../../store/selectors/currentStep/currentStep';
import {getIsSelectedByKey} from '../../store/selectors/paymentStep/paymentStep';

import {PaymentWrapperConnected} from '../paymentWrapper/paymentWrapper';

import {PaymentVenmoButtonConnected} from './paymentVenmoButton/paymentVenmoButton';

import s from './paymentPrimerVenmo.scss';

type PropsType = {
    isSelected: boolean;
};

/**
 * Venmo with primer UI component
 */
const PaymentVenmoPrimer: FC<PropsType> = ({isSelected}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const {manager} = usePrimerForRedirectablePayments({
        externalMethodType: 'BRAINTREE_VENMO',
        internalMethodType: PAYMENTS.METHOD_PRIMER_VENMO,
    });

    const {error} = useGetErrorAndSendAnalytics(PAYMENTS.METHOD_PRIMER_VENMO);

    const onVenmoClick = () => {
        if (manager) manager.start();
    };

    return (
        <PaymentWrapperConnected
            title={
                <div className={classNames(s.title, {[s.titleFacelift]: isFacelift})}>
                    <Icon icon={VenmoIcon} />
                </div>
            }
            code={PAYMENTS.METHOD_PRIMER_VENMO}
            isSelected={isSelected}
        >
            <PaymentVenmoButtonConnected
                isPaymentAuthorized={false}
                onClick={onVenmoClick}
                venmoErrorMessage={error}
            />
        </PaymentWrapperConnected>
    );
};

/**
 * Renders venmo primer method only in payment step
 */
export const PaymentVenmoPrimerContainer: FC<
    PropsType & {
        currentStep: STEPS;
    }
> = ({currentStep, ...props}) => {
    if (currentStep !== STEPS.PAYMENT_STEP) return null;

    return <PaymentVenmoPrimer {...props} />;
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    currentStep: getCurrentStep(store),
    isSelected: getIsSelectedByKey(store, PAYMENTS.METHOD_PRIMER_VENMO),
});

export const PaymentVenmoPrimerConnected = connect(mapStateToProps)(PaymentVenmoPrimerContainer);
